module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/idodetail-e1f287dbe7119123bd74b18c9ab8119b.png";